import { render, staticRenderFns } from "./HeaderActionPageButtons.vue?vue&type=template&id=4626e5e2"
import script from "./HeaderActionPageButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionPageButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4626e5e2')) {
      api.createRecord('4626e5e2', component.options)
    } else {
      api.reload('4626e5e2', component.options)
    }
    module.hot.accept("./HeaderActionPageButtons.vue?vue&type=template&id=4626e5e2", function () {
      api.rerender('4626e5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderActionPageButtons.vue"
export default component.exports